import PropTypes from 'prop-types';
import PrediabetesTestForm from '../prediabetedTestForm';

export function PrediabetesMeasures({ clientProductId, clientProductUuid, handleChangeMode }) {
  return (
    <div>
      <PrediabetesTestForm
        clientProductId={clientProductId}
        clientProductUuid={clientProductUuid}
        handleChangeMode={handleChangeMode}
      ></PrediabetesTestForm>
    </div>
  );
}

PrediabetesMeasures.propTypes = {
  clientProductId: PropTypes.string,
  clientProductUuid: PropTypes.string,
  handleChangeMode: PropTypes.func
};
